/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Notice_DutiesInputs */

const en_seller_notice_duties = /** @type {(inputs: Seller_Notice_DutiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your contract is with the seller, which answers for what it sells, refunds and your consumer rights. Complete Athlete runs the app and is not a party to the contract.`)
};

const pl_seller_notice_duties = /** @type {(inputs: Seller_Notice_DutiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umowę zawierasz ze sprzedawcą, który odpowiada za to, co sprzedaje, za zwroty i Twoje prawa konsumenta. Complete Athlete prowadzi aplikację i nie jest stroną umowy.`)
};

/**
* | output |
* | --- |
* | "Your contract is with the seller, which answers for what it sells, refunds and your consumer rights. Complete Athlete runs the app and is not a party to the ..." |
*
* @param {Seller_Notice_DutiesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seller_notice_duties = /** @type {((inputs?: Seller_Notice_DutiesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Notice_DutiesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seller_notice_duties(inputs)
	return en_seller_notice_duties(inputs)
});